module.exports = __webpack_public_path__ + "img/Frame 5117.a9fdeb23.jpg";